"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var PriceList_1 = require("../model/PriceList");

var PriceListConverter_1 = require("./PriceListConverter");
/**
 * Implementation of {@link PriceListConverter}
 *
 * @author RV
 * @author VRu
 */


var PriceListConverterImpl =
/*#__PURE__*/
function (_PriceListConverter_) {
  _inherits(PriceListConverterImpl, _PriceListConverter_);

  function PriceListConverterImpl() {
    _classCallCheck(this, PriceListConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceListConverterImpl).apply(this, arguments));
  }

  _createClass(PriceListConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceList_1.PriceList(PriceList_1.PriceList.schema.id.valueOf(conversions.documentToClassId(source)), PriceList_1.PriceList.schema.externalId.valueOfField(source), PriceList_1.PriceList.schema.name.valueOfField(source), PriceList_1.PriceList.schema.priority.valueOfField(source), PriceList_1.PriceList.schema.priceListTypeId.valueOf(conversions.toClassReferenceId(source.priceListTypeId)), PriceList_1.PriceList.schema.groupOfSiteId.valueOf(conversions.toClassReferenceId(source.groupOfSiteId)), utils_1.Utils.isValueMissing(source.processed) ? false
      /* Default value, updater has blocked testing for long time */
      : PriceList_1.PriceList.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name,
        priority: source.priority,
        priceListTypeId: conversions.toDocumentReferenceId(source.priceListTypeId),
        groupOfSiteId: conversions.toDocumentReferenceId(source.groupOfSiteId),
        processed: source.processed
      });
      return result;
    }
  }]);

  return PriceListConverterImpl;
}(PriceListConverter_1.PriceListConverter);

exports.PriceListConverterImpl = PriceListConverterImpl;